import dayjs from 'dayjs';
import { mapState } from 'vuex';

import { NO_DEPARTMENT_ID, USER_LEVEL_MAPPING } from '@/utils/constants';
import { formatPrice } from '@/utils/helper';

export default {
  name: 'CanceledMemberTable',
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      isAllDepartmentSelected: true,
      selectedDepartments: [],
      toggleAllDetail: false,
    };
  },
  watch: {
    members: {
      handler(newVal) {
        if (newVal?.length && this.isAllDepartmentSelected) {
          this.selectAllDepartments(true);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState('orders', ['departments']),
    departmentInfo() {
      const result = {};
      this.members.forEach((member) => {
        const currentDepartment = result?.[member.department_id];
        result[member.department_id] = currentDepartment ? currentDepartment + 1 : 1;
      });
      return result;
    },
    filteredMembers() {
      return this.members.filter(
        (member) => this.selectedDepartments.includes(String(member.department_id)),
      );
    },
    isAllDetailOpened() {
      return this.openedRowDetail?.length === this.members?.length;
    },
    members() {
      return this.value || [];
    },
    openedRowDetail() {
      this.members.sort((a, b) => a.name.localeCompare(b.name));
      return this.toggleAllDetail ? this.members.map((i) => i.id) : [];
    },
    sortedDepartmentInfos() {
      const keys = Object.keys(this.departmentInfo).filter((id) => +id !== NO_DEPARTMENT_ID);
      if (this.departmentInfo[NO_DEPARTMENT_ID] > 0) {
        keys.push(NO_DEPARTMENT_ID);
      }

      return keys.map((id) => ({ id: String(id), count: this.departmentInfo[id] }));
    },
  },
  methods: {
    cancelAt(time) {
      return dayjs(time).format('YYYY/MM/DD HH:mm:ss');
    },
    cancelBy(row = {}) {
      const { cancel_by: by = {}, member_id: mid } = row || {};
      const { id, name, role } = by;
      if (mid === id) {
        return '本人';
      }

      const roleText = USER_LEVEL_MAPPING?.find(({ key }) => key === role)?.name || '';
      return `${roleText}-${name}`;
    },
    columnThAttrs() {
      return {
        class: 'text-xs',
      };
    },
    departmentChanged() {
      this.isAllDepartmentSelected = this.selectedDepartments
        .length === Object.keys(this.departmentInfo).length;
    },
    formatPrice,
    getDepartmentName(departmentId) {
      const department = this.departments.find((d) => String(d.id) === String(departmentId));
      return department?.name;
    },
    itemRowClass(item) {
      if (this.openedRowDetail.includes(item.id)) {
        return 'member-table__row member-table__row--opened';
      }
      return 'member-table__row';
    },
    selectAllDepartments(selectAll) {
      this.selectedDepartments = selectAll ? Object.keys(this.departmentInfo) : [];
    },
    sortOptions(options) {
      return [...options].sort((a, b) => a.index - b.index);
    },
  },
};
